import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const inboundEmailsApi = {
  getAll(
    params?: cyrian.api.inboundEmails.GetParams,
  ): ApiResponse<WrappedResult<{ items: cyrian.api.inboundEmails.InboundEmail[]; count: number }>> {
    return request({
      method: 'get',
      url: '/inbound-emails',
      params,
    });
  },
  mailboxStatus(): ApiResponse<WrappedResult<cyrian.api.inboundEmails.MailboxStatus>> {
    return request({
      method: 'get',
      url: '/inbound-emails/mailbox-status',
    });
  },
  dismiss(id: number): ApiResponse<WrappedResult<cyrian.api.inboundEmails.InboundEmail>> {
    return request({
      method: 'post',
      url: `/inbound-emails/${id}/dismiss`,
    });
  },
};

export default inboundEmailsApi;
